import { render } from "./Aggiunte.vue?vue&type=template&id=5aa21460&scoped=true"
import script from "./Aggiunte.vue?vue&type=script&lang=js"
export * from "./Aggiunte.vue?vue&type=script&lang=js"

import "./Aggiunte.vue?vue&type=style&index=0&id=5aa21460&scoped=true&lang=css"

import exportComponent from "/root/frontTioPizza/mymenucli/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5aa21460"]])

export default __exports__